import { EventCode } from '@/enums/events-enum';
import { cookieHandler, localStorageHandler } from '@/store/middleware';
import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';

import { loadState } from './localStorage';
import appReducer from './reducerApp';
import settingsReducer from './reducerSettings';
import userReducer from './reducerUser';

const preloadedState: object = loadState('store') || {};

const store = configureStore({
  reducer: {
    user: userReducer,
    app: appReducer,
    settings: settingsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([logger, cookieHandler, localStorageHandler]),
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
export default store;

const errorEventHandler = (event: Event) => {
  console.log(`event type: ${event.type}`);
  // if (event.type === EventCode.GRAPHQL_ERROR_EVENT) {
  // } else if (event.type === EventCode.NETWORK_ERROR_EVENT) {
  // }
};

window.addEventListener(EventCode.GRAPHQL_ERROR_EVENT, errorEventHandler);
window.addEventListener(EventCode.NETWORK_ERROR_EVENT, errorEventHandler);
// The storage event is only fired in other tabs or windows, not in the same tab where the local storage change occurs.
window.addEventListener(EventCode.STORAGE_CHANGE_EVENT, () => {
  console.log('Change to local storage!');
});
